// src/features/messages/services/messages.js
import { apiClient } from '../../../services/api/client';

const BASE = '/api/v1/messages';

export const messagesAPI = {
  // Messages sent by or to me, latest activity first ({ unread_only, limit, offset })
  list: (params = {}) => apiClient.get(`${BASE}/`, { params }),

  get: (messageId) => apiClient.get(`${BASE}/${messageId}`),

  // { content, audience_all, role_ids, staff_member_ids }
  send: (data) => apiClient.post(`${BASE}/`, data),

  remove: (messageId) => apiClient.delete(`${BASE}/${messageId}`),

  markRead: (messageId) => apiClient.post(`${BASE}/${messageId}/read`),

  markAllRead: () => apiClient.post(`${BASE}/read-all`),

  addReaction: (messageId, reaction) => apiClient.put(`${BASE}/${messageId}/reactions/${reaction}`),

  removeReaction: (messageId, reaction) => apiClient.delete(`${BASE}/${messageId}/reactions/${reaction}`),

  addComment: (messageId, content) => apiClient.post(`${BASE}/${messageId}/comments`, { content }),

  deleteComment: (messageId, commentId) => apiClient.delete(`${BASE}/${messageId}/comments/${commentId}`),

  // Staff and roles in my department, for picking recipients
  audienceOptions: () => apiClient.get(`${BASE}/audience-options`),
};
